import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getFullUrl } from 'hubspot-url-utils';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function InstallSuccess() {
  useEffect(() => {
    window.opener.postMessage({
      type: 'INSTALL_SUCCESS'
    }, getFullUrl('app'));
  }, []);
  return /*#__PURE__*/_jsx(LoadingSpinner, {});
}